import React, { useEffect, useRef, useState } from "react";
import { Headphones, Pause, Play, RotateCcw } from "lucide-react";
import { speak } from "@/context/A11yContext";

const pill = "inline-flex items-center gap-1.5 rounded-full border px-4 py-2 text-sm font-medium transition-colors hover:border-primary hover:text-primary";

// Reads every lesson section in order; reports the section being read so the page can highlight and follow it.
export const WholeLessonListen = ({ sections, rate = 1, onActive }) => {
  const [state, setState] = useState("idle");
  const run = useRef(0);
  const active = useRef(false);
  const cb = useRef(onActive);
  cb.current = onActive;

  const stop = () => { active.current = false; setState("idle"); cb.current?.(null); };
  useEffect(() => {
    const onOther = (e) => { if (e.detail !== "whole" && active.current) stop(); };
    window.addEventListener("jt-speak", onOther);
    return () => { window.removeEventListener("jt-speak", onOther); if (active.current) window.speechSynthesis?.cancel(); };
  }, []);

  const playFrom = (n, token) => {
    if (n >= sections.length) return stop();
    cb.current?.(n);
    const s = sections[n];
    speak(`${s.heading}. ${s.text || ""}`, rate, { id: "whole", onEnd: () => { if (active.current && run.current === token) playFrom(n + 1, token); } });
  };
  const start = () => {
    if (!("speechSynthesis" in window)) return;
    active.current = true;
    const token = (run.current += 1);
    setState("playing");
    playFrom(0, token);
  };
  const toggle = () => {
    if (state === "idle") return start();
    if (state === "playing") { window.speechSynthesis.pause(); setState("paused"); }
    else { window.speechSynthesis.resume(); setState("playing"); }
  };
  const Icon = state === "playing" ? Pause : state === "paused" ? Play : Headphones;
  return (
    <div className="mt-4 flex flex-wrap items-center gap-2" data-testid="whole-lesson-listen">
      <button onClick={toggle} data-testid="whole-lesson-listen-btn"
        className={`${pill} ${state === "idle" ? "border-border text-foreground" : "border-primary bg-primary/10 text-primary"}`}>
        <Icon size={15} /> {state === "playing" ? "Pause" : state === "paused" ? "Resume" : "Listen to whole lesson"}
      </button>
      {state !== "idle" && (
        <button onClick={start} data-testid="whole-lesson-listen-restart" className={`${pill} border-border text-muted-foreground`}>
          <RotateCcw size={14} /> From start
        </button>
      )}
    </div>
  );
};
